import React, { useState, useEffect, useContext } from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { useAuth0 } from '@auth0/auth0-react'
import { StoreContext } from '@context/store-context'

import Logo from '@icons/logo'
import { Navigation } from '@components/Header/Navigation/Navigation'
import { NavigationMobile } from '@components/Header/Navigation/NavigationMobile'
import { CartButton } from '@components/CartButton/CartButton'
import AccountButton from '@components/AccountButton'
import { Toast } from '@components/toast'

import { Navbar, Collapse, Typography } from '@material-tailwind/react'
import { CgMenu, CgClose, CgSearch } from 'react-icons/cg'
import './Header.less'

export function Header({ className = '' }) {
  const { cart, loading, didJustAddToCart } = useContext(StoreContext)
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0()
  const [menus, setMenus] = useState([])
  const [openNav, setOpenNav] = useState(false)

  const dataQuery = useStaticQuery(graphql`
    {
      contentfulJson(name: { eq: "navigations" }) {
        data {
          internal {
            content
          }
        }
      }
    }
  `)

  useEffect(() => {
    const data = dataQuery?.contentfulJson?.data || []
    if (Array.isArray(data) && data.length > 0) {
      const parsedMenus = data.map((item) => JSON.parse(item.internal.content))
      setMenus(sortByOrderRecursive(parsedMenus))
    }
  }, [dataQuery])

  const sortByOrderRecursive = (items) => {
    if (!Array.isArray(items)) return []
    return items
      .map((item) => ({
        ...item,
        children: item.children ? sortByOrderRecursive(item.children) : [],
      }))
      .sort((a, b) => a.order - b.order)
  }

  const quantity = (cart?.lines?.nodes || cart?.lines?.edges || []).reduce(
    (total, item) => {
      // 处理两种数据结构：nodes直接返回item，edges需要访问node
      const lineItem = item?.node || item
      return total + (lineItem?.quantity || 0)
    },
    0,
  )

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 960) setOpenNav(false)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    document.body.style.overflow = openNav ? 'hidden' : 'auto'
  }, [openNav])

  return (
    <header className={`header-container sticky top-0 z-[999] ${className}`}>
      <Navbar className="mx-auto px-0 py-0 rounded-none max-w-none shadow-none border-0 border-b border-[#E4E4E4]">
        <div className="responsive-frame flex items-center justify-between text-blue-gray-900">
          <Typography
            variant="h6"
            className="mr-4 cursor-pointer py-1.5 basis-20 flex-grow-0 l:flex-1"
          >
            <Link to="/">
              <Logo color="#000" className="w-[115px] hover:text-black" />
            </Link>
          </Typography>

          <div className="flex-1 justify-center flex l:hidden">
            <Navigation menus={menus} />
          </div>

          <div
            className="hidden l:block text-fluid-md cursor-pointer text-[var(--text-color-secondary)] hover:text-black ml-3"
            onClick={() => setOpenNav(!openNav)}
          >
            {openNav ? <CgClose /> : <CgMenu />}
          </div>
          <Link to="/search">
            <CgSearch className="text-fluid-md cursor-pointer text-[var(--text-color-secondary)] hover:text-black ml-3" />
          </Link>
          <CartButton quantity={quantity} />
          <AccountButton />

          {/* <div className="flex items-center gap-3 pl-2">
            {!isAuthenticated ? (
              <button
                onClick={() => loginWithRedirect()}
                className="text-sm font-medium text-gray-700 hover:text-black transition-colors"
              >
                Sign in
              </button>
            ) : (
              <div className="relative group">
                <div className="flex items-center gap-2">
                  <img
                    src={user?.picture}
                    alt={user?.name || 'User Avatar'}
                    className="w-8 h-8 rounded-full border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer"
                    onError={(e) => {
                      e.target.style = 'display: none;'
                    }}
                    title={user?.name || user?.email}
                  />
                  <span className="text-sm font-medium text-gray-700 hidden sm:block">
                    {user?.name || user?.email}
                  </span>
                </div>
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 ease-in-out z-10">
                  <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
                    <div className="font-medium">{user?.name}</div>
                    <div className="text-xs text-gray-500 truncate">
                      {user?.email}
                    </div>
                  </div>
                  <button
                    onClick={() =>
                      logout({
                        logoutParams: { returnTo: window.location.origin },
                      })
                    }
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-red-600 transition-colors"
                  >
                    Logout
                  </button>
                </div>
              </div>
            )}
          </div> */}
        </div>
        <Collapse className="hidden l:block w-full" open={openNav}>
          <NavigationMobile
            menus={menus}
            onNavChange={() => setOpenNav(false)}
          />
        </Collapse>
      </Navbar>

      <Toast show={loading || didJustAddToCart}>
        {!didJustAddToCart ? 'Updating…' : 'Added to cart'}
      </Toast>
    </header>
  )
}
